(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu-personalizado"] && !Shopify.designMode) return;
  try {
    class MegaMenuPersonalizado extends HTMLElement {
    constructor() {
      super();
      this.closeTimeout = null;
    }

    connectedCallback() {
      this.items1 = Array.from(this.querySelectorAll('[data-menu-nivel1]'));

      this.items1.forEach((item1) => {
        const trigger = item1.querySelector('[data-menu-trigger]');
        if (!trigger) return;

        item1.addEventListener('mouseenter', () => this.openItem(item1));
        item1.addEventListener('mouseleave', () => this.scheduleClose());
        trigger.addEventListener('focus', () => this.openItem(item1));

        const itemsA = item1.querySelectorAll('li[data-l2-key]');
        itemsA.forEach((itemA) => {
          itemA.addEventListener('mouseenter', () => this.activateL2(item1, itemA));
        });

        const itemsB = item1.querySelectorAll('li[data-l3-key]');
        itemsB.forEach((itemB) => {
          itemB.addEventListener('mouseenter', () => this.activateL3(item1, itemB));
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeAll();
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeAll();
      });
    }

    openItem(item1) {
      clearTimeout(this.closeTimeout);
      this.items1.forEach((item) => {
        const isCurrent = item === item1;
        item.classList.toggle('menu-mega-personalizado__item-nivel1--abierto', isCurrent);
        const trigger = item.querySelector('[data-menu-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', isCurrent ? 'true' : 'false');
      });
    }

    scheduleClose() {
      this.closeTimeout = setTimeout(() => this.closeAll(), 150);
    }

    closeAll() {
      this.items1.forEach((item) => {
        item.classList.remove('menu-mega-personalizado__item-nivel1--abierto');
        const trigger = item.querySelector('[data-menu-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    activateL2(item1, itemA) {
      const l2Key = itemA.getAttribute('data-l2-key');

      item1.querySelectorAll('li[data-l2-key]').forEach((el) => {
        el.classList.toggle('menu-mega-personalizado__item-columna-a--activo', el === itemA);
      });

      item1.querySelectorAll('.menu-mega-personalizado__grupo-columna-b').forEach((el) => {
        el.classList.toggle(
          'menu-mega-personalizado__grupo-columna-b--activo',
          el.getAttribute('data-l2-key') === l2Key
        );
      });

      const grupoB = item1.querySelector('.menu-mega-personalizado__grupo-columna-b[data-l2-key="' + l2Key + '"]');
      const primerL3 = grupoB ? grupoB.querySelector('li[data-l3-key]') : null;
      if (primerL3) this.activateL3(item1, primerL3);
    }

    activateL3(item1, itemB) {
      const l3Key = itemB.getAttribute('data-l3-key');

      item1.querySelectorAll('li[data-l3-key]').forEach((el) => {
        el.classList.toggle('menu-mega-personalizado__item-columna-b--activo', el === itemB);
      });

      item1.querySelectorAll('.menu-mega-personalizado__grupo-columna-c').forEach((el) => {
        el.classList.toggle(
          'menu-mega-personalizado__grupo-columna-c--activa',
          el.getAttribute('data-l3-key') === l3Key
        );
      });

      item1.querySelectorAll('.menu-mega-personalizado__visual-item').forEach((el) => {
        el.classList.toggle(
          'menu-mega-personalizado__visual-item--activo',
          el.getAttribute('data-l3-key') === l3Key
        );
      });
    }
  }

  customElements.define('mega-menu-personalizado', MegaMenuPersonalizado);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class TarjetaAgregarCarrito extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('.tarjeta-agregar-carrito__boton');
      this.confirmation = this.querySelector('.tarjeta-agregar-carrito__confirmacion');
      this.variantId = this.getAttribute('data-variant-id');
      this.productUrl = this.getAttribute('data-product-url');

      if (!this.button) return;

      this.onClick = this.handleClick.bind(this);
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onClick);
    }

    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.button.disabled) return;

      if (!this.variantId) {
        if (this.productUrl) {
          window.location.href = this.productUrl;
        }
        return;
      }

      this.button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: this.variantId, quantity: 1 }] }),
      })
        .then((response) => {
          if (!response.ok) throw new Error('No se pudo agregar al carrito');
          return response.json();
        })
        .then(() => {
          this.showConfirmation('Añadido al carrito');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(() => {
          this.showConfirmation('No se pudo agregar');
        })
        .finally(() => {
          this.button.disabled = false;
        });
    }

    showConfirmation(text) {
      if (!this.confirmation) return;
      this.confirmation.textContent = text;
      this.confirmation.classList.add('tarjeta-agregar-carrito__confirmacion--visible');
      setTimeout(() => {
        this.confirmation.classList.remove('tarjeta-agregar-carrito__confirmacion--visible');
      }, 2000);
    }
  }

  customElements.define('tarjeta-agregar-carrito', TarjetaAgregarCarrito);
  } catch(e) { console.error(e); }
})();

})();
